/* tslint:disable */
/* eslint-disable */
/**
 * Stotles App API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetAppApiTokenResponse
 */
export interface GetAppApiTokenResponse {
    /**
     * 
     * @type {string}
     * @memberof GetAppApiTokenResponse
     */
    token: string;
}

/**
 * Check if a given object implements the GetAppApiTokenResponse interface.
 */
export function instanceOfGetAppApiTokenResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "token" in value;

    return isInstance;
}

export function GetAppApiTokenResponseFromJSON(json: any): GetAppApiTokenResponse {
    return GetAppApiTokenResponseFromJSONTyped(json, false);
}

export function GetAppApiTokenResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAppApiTokenResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': json['token'],
    };
}

export function GetAppApiTokenResponseToJSON(value?: GetAppApiTokenResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
    };
}

